module.exports = __webpack_public_path__ + "static/img/degustazione.ebdcd50.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/degustazione.png
// module id = CPk6
// module chunks = 1